(() => {
  if (window.RistaOwnCartPreview) return;

  const RISTA_PRODUCT_ID = 15651023257977;
  const ACKNOWLEDGEMENT_ATTRIBUTE = 'rista_personalized_notice__';
  const ACKNOWLEDGEMENT_SESSION_KEY = 'rista:personalized-withdrawal-notice';
  const ACKNOWLEDGEMENT_TEXT = 'Kenntnis bestätigt: personalisierte Anfertigung; kein Widerrufsrecht gemäß § 312g Abs. 2 Nr. 1 BGB.';
  let refreshTimer;
  let refreshing = false;
  let gateState = { allowed: true, hasPersonalizedItems: false };

  const checkoutButtons = () => [...document.querySelectorAll('button, input[type="submit"]')]
    .filter((button) => {
      const label = `${button.textContent || ''} ${button.value || ''} ${button.name || ''}`.toLowerCase();
      return button.matches('[name="checkout"], .cart__checkout-button')
        || label.includes('auschecken')
        || label.includes('checkout');
    });

  const cartFingerprint = (items) => items
    .filter((item) => Number(item.product_id) === RISTA_PRODUCT_ID)
    .map((item) => `${item.key}:${item.quantity}:${item.properties?.['_rista_design_id'] || ''}`)
    .sort()
    .join('|');

  const isDesignApproved = (item) => (
    Boolean(item.properties?.['_rista_design_id'])
    && item.properties?.Design === 'Kundenfreigabe erfolgt'
  );

  const noticeHosts = () => new Set(checkoutButtons().map((button) => (
    button.closest('.cart__ctas, .cart-drawer__footer') || button.parentElement
  )).filter(Boolean));

  const ensureAcknowledgementNotices = (required, acknowledged, fingerprint) => {
    if (!required) {
      document.querySelectorAll('[data-rista-withdrawal-notice]').forEach((notice) => notice.remove());
      return;
    }

    let index = 0;
    for (const host of noticeHosts()) {
      let notice = host.querySelector('[data-rista-withdrawal-notice]');
      if (!notice) {
        index += 1;
        notice = document.createElement('div');
        notice.className = 'rista-withdrawal-notice';
        notice.dataset.ristaWithdrawalNotice = 'true';

        const label = document.createElement('label');
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.required = true;
        checkbox.id = `rista-withdrawal-acknowledgement-${index}`;
        checkbox.dataset.ristaWithdrawalAcknowledgement = 'true';

        const copy = document.createElement('span');
        copy.append('Ich habe verstanden, dass das RISTA Board nach meiner individuellen Auswahl angefertigt wird und für diesen personalisierten Artikel kein Widerrufsrecht besteht (§ 312g Abs. 2 Nr. 1 BGB). Gesetzliche Gewährleistungsrechte bei Mängeln bleiben unberührt. ');
        const link = document.createElement('a');
        link.href = '/pages/faq';
        link.textContent = 'Mehr dazu in den FAQ';
        copy.append(link);

        const status = document.createElement('small');
        status.dataset.ristaWithdrawalStatus = 'true';
        status.setAttribute('aria-live', 'polite');
        label.append(checkbox, copy);
        notice.append(label, status);
        host.insertBefore(notice, host.firstChild);
      }

      const checkbox = notice.querySelector('[data-rista-withdrawal-acknowledgement]');
      checkbox.checked = acknowledged;
      checkbox.dataset.cartFingerprint = fingerprint;
    }
  };

  const setCheckoutGate = ({ hasPersonalizedItems, designApproved, acknowledged, fingerprint }) => {
    const allowed = designApproved && (!hasPersonalizedItems || acknowledged);
    gateState = { allowed, hasPersonalizedItems };
    ensureAcknowledgementNotices(hasPersonalizedItems, acknowledged, fingerprint);

    for (const button of checkoutButtons()) {
      if (!allowed) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.dataset.ristaCheckoutLocked = 'true';
      } else if (button.dataset.ristaCheckoutLocked === 'true') {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        delete button.dataset.ristaCheckoutLocked;
      }
    }

    for (const accelerated of document.querySelectorAll('shopify-accelerated-checkout-cart, .cart__additional-checkout-buttons')) {
      accelerated.hidden = hasPersonalizedItems || !designApproved;
    }

    const summary = document.querySelector('.cart__summary-totals, .cart__ctas');
    let warning = document.querySelector('[data-rista-cart-approval-warning]');
    if (!designApproved && summary && !warning) {
      warning = document.createElement('p');
      warning.className = 'rista-cart-approval-warning';
      warning.dataset.ristaCartApprovalWarning = 'true';
      warning.setAttribute('role', 'alert');
      warning.textContent = 'Mindestens ein personalisiertes Board besitzt keine gültige Entwurfsfreigabe. Bitte entferne es und füge es nach der Vorschauprüfung erneut hinzu.';
      summary.parentElement?.insertBefore(warning, summary);
    } else if (designApproved) {
      warning?.remove();
    }
  };

  const applyPreviews = async () => {
    if (refreshing) return;
    refreshing = true;
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      const byKey = new Map(cart.items.map((item) => [item.key, item]));
      const personalizedItems = cart.items.filter((item) => Number(item.product_id) === RISTA_PRODUCT_ID);
      const fingerprint = cartFingerprint(personalizedItems);
      const acknowledged = Boolean(fingerprint)
        && sessionStorage.getItem(ACKNOWLEDGEMENT_SESSION_KEY) === fingerprint;
      const designApproved = personalizedItems.every(isDesignApproved);
      setCheckoutGate({
        hasPersonalizedItems: personalizedItems.length > 0,
        designApproved,
        acknowledged,
        fingerprint,
      });

      for (const row of document.querySelectorAll('.cart-items__table-row[data-key]')) {
        const item = byKey.get(row.dataset.key);
        const preview = item?.properties?.['_rista_preview_url'];
        if (!preview) continue;
        const image = row.querySelector('.cart-items__media-image');
        if (!image || image.dataset.ristaCustomPreview === preview) continue;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = preview;
        image.alt = `Deine konfigurierte Vorschau: ${item.product_title}`;
        image.dataset.ristaCustomPreview = preview;
      }
    } catch (error) {
      console.error('[RISTA] Personalisierter Warenkorb konnte nicht geprüft werden.', error);
    } finally {
      refreshing = false;
    }
  };

  const scheduleRefresh = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(applyPreviews, 80);
  };

  document.addEventListener('change', async (event) => {
    const checkbox = event.target.closest?.('[data-rista-withdrawal-acknowledgement]');
    if (!checkbox) return;
    const checked = checkbox.checked;
    const fingerprint = checkbox.dataset.cartFingerprint || '';
    document.querySelectorAll('[data-rista-withdrawal-acknowledgement]').forEach((field) => {
      field.checked = checked;
      field.disabled = true;
    });
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: { [ACKNOWLEDGEMENT_ATTRIBUTE]: checked ? ACKNOWLEDGEMENT_TEXT : '' },
        }),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      if (checked && fingerprint) sessionStorage.setItem(ACKNOWLEDGEMENT_SESSION_KEY, fingerprint);
      else sessionStorage.removeItem(ACKNOWLEDGEMENT_SESSION_KEY);
      await applyPreviews();
    } catch (error) {
      checkbox.checked = !checked;
      const status = checkbox.closest('[data-rista-withdrawal-notice]')?.querySelector('[data-rista-withdrawal-status]');
      if (status) status.textContent = 'Die Bestätigung konnte nicht gespeichert werden. Bitte versuche es erneut.';
      console.error('[RISTA] Kenntnisbestätigung konnte nicht gespeichert werden.', error);
    } finally {
      document.querySelectorAll('[data-rista-withdrawal-acknowledgement]').forEach((field) => {
        field.disabled = false;
      });
      scheduleRefresh();
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('button, input[type="submit"]');
    if (!button || !checkoutButtons().includes(button) || gateState.allowed) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    document.querySelector('[data-rista-withdrawal-acknowledgement]:not(:checked)')?.focus();
  }, true);

  document.addEventListener('submit', (event) => {
    if (gateState.allowed || !event.submitter || !checkoutButtons().includes(event.submitter)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  window.RistaOwnCartPreview = { refresh: scheduleRefresh };
  window.RistaCartPreview = window.RistaOwnCartPreview;
  const initialCartCount = Number.parseInt(
    document.querySelector('.rista-header__count')?.textContent || '0',
    10,
  );
  if (initialCartCount > 0) {
    document.addEventListener('DOMContentLoaded', scheduleRefresh, { once: true });
  }
  for (const eventName of ['cart:view', 'cart:lines:update', 'cart:update']) {
    document.addEventListener(eventName, scheduleRefresh);
  }
  for (const root of document.querySelectorAll('cart-items-component, cart-drawer-component, .cart-drawer')) {
    new MutationObserver(scheduleRefresh).observe(root, { childList: true, subtree: true });
  }
})();
